import React from 'react';
import { Box, Flex, Heading, Text, HStack, useColorModeValue, ResponsiveValue } from '@chakra-ui/react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  size?: ResponsiveValue<'sm' | 'md' | 'lg'>;
  icon?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, badge, actions, size = 'lg', icon }) => {
  const textColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      align={{ base: 'start', md: 'center' }}
      mb={{ base: 6, md: 8 }}
      gap={4}
    >
      <Box>
        <HStack mb={2} spacing={3} align="center">
          {icon && <Box>{icon}</Box>}
          <Heading size={size} fontWeight="700" lineHeight="tight">
            {title}
          </Heading>
          {badge && <Box>{badge}</Box>}
        </HStack>
        {subtitle && (
          <Text
            color={textColor}
            fontSize={{ base: 'sm', md: 'md' }}
            display={{ base: 'none', sm: 'block' }}
            maxW="600px"
          >
            {subtitle}
          </Text>
        )}
      </Box>
      {actions && (
        <HStack spacing={{ base: 2, md: 4 }} align="center">
          {actions}
        </HStack>
      )}
    </Flex>
  );
};

export default PageHeader;
